// Empty-state for orgs that haven't enabled the Service Desk add-on.
// Pricing copy comes from the ₹600/user/month add-on tier agreed with the
// founder. Routes admin users to /billing where they'd contact sales.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lifebuoy, CheckCircle, Lock } from '@phosphor-icons/react';
import { Button } from '../ui/button';
import AppFooter from '../AppFooter';

export default function ServiceDeskUpsell() {
  const navigate = useNavigate();
  return (
    <div className="flex-1 overflow-auto bg-zinc-50" data-testid="sd-upsell">
      <div className="max-w-3xl mx-auto px-8 py-16">
        <div className="bg-white border border-zinc-200 rounded-xl p-10 text-center shadow-sm">
          <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-4 ring-1 ring-blue-100">
            <Lifebuoy size={26} className="text-blue-600" weight="fill" />
          </div>
          <h1 className="text-2xl font-bold text-zinc-900 font-['Outfit']">Inspiro Service Desk</h1>
          <p className="text-sm text-zinc-500 mt-2 max-w-md mx-auto">
            Run IT, HR, and internal support like the pros. Spin up branded portals,
            queue tickets, and resolve requests with SLAs — all from inside Inspiro Projects.
          </p>

          <div className="mt-6 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-5 ring-1 ring-blue-100 text-left">
            <div className="flex items-baseline justify-between mb-3">
              <div>
                <p className="text-[11px] uppercase tracking-wider text-blue-700 font-bold">Add-on</p>
                <p className="text-zinc-900 font-semibold mt-0.5">Service Desk</p>
              </div>
              <div className="text-right">
                <p className="text-2xl font-bold text-zinc-900 font-['Outfit']">₹600<span className="text-sm font-normal text-zinc-500">/user/mo</span></p>
                <p className="text-[11px] text-zinc-500">On top of your base plan</p>
              </div>
            </div>
            <ul className="space-y-1.5 text-sm text-zinc-700">
              {[
                'Multiple branded portals (IT, HR, Facilities…)',
                'Custom request forms per category',
                'Queue, assign, and triage with priorities',
                'Internal vs. external comments',
                'Per-portal ticket numbering (e.g., IT-42)',
              ].map(item => (
                <li key={item} className="flex items-start gap-2">
                  <CheckCircle size={15} weight="fill" className="text-emerald-500 flex-shrink-0 mt-0.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-6 flex items-center justify-center gap-3">
            <Button onClick={() => navigate('/billing')} data-testid="sd-upsell-cta">
              <Lock size={14} className="mr-1.5" /> Talk to sales
            </Button>
            <Button variant="ghost" onClick={() => navigate('/dashboard')}>Back to workspace</Button>
          </div>
          <p className="text-[11px] text-zinc-400 mt-4">
            Once enabled, Service Desk appears in your sidebar for every admin and assigned agent.
          </p>
        </div>
      </div>
      <AppFooter />
    </div>
  );
}
